import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTriggerRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastTriggerRoute() {
  const { broadcastId, triggerId } = Route.useParams();
  return <BroadcastTriggerRouteView broadcastId={broadcastId} triggerId={triggerId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/$triggerId/',
)({
  component: BroadcastTriggerRoute,
});
